import { ClientGalleryOrderInformation, OrderInformationContext } from 'components/pages/Gallery/_main/ClientGallery/ClientGalleryOrderInformation'
import { FC, useMemo } from 'react'
import { GalleryAssignmentContextProvider, GalleryDealContextProvider } from 'components/pages/Gallery/_main/contexts'

import { AnalyticsEvent } from 'utils/analytics'
import { ClientPropertyEmptyContent } from '../../ClientPropertyEmptyContent'
import { ClientPropertyPriceSummaryCard } from '../../ClientPropertyPriceSummaryCard'
import { GRAY_900 } from 'constants/styling/theme'
import Grid from '@mui/material/Grid'
import { Path } from 'constants/router'
import { ShoppingCartOutlined } from '@mui/icons-material'
import Stack from '@mui/material/Stack'
import { useClientProperty } from '../contexts'
import { useGetPropertyOrders } from 'dataQueries'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useUserData } from 'components/contexts/UserDataContext'

export const ClientPropertyOrdersPage: FC = () => {
  const { t } = useTranslation(['property'])
  const navigate = useNavigate()

  const { propertyId, handleClickOnEmptyAction } = useClientProperty()
  const { userPropertyWorkspaceId } = useUserData()

  const getPropertyOrdersQuery = useGetPropertyOrders(propertyId, userPropertyWorkspaceId)
  const propertyOrdersData = useMemo(() => getPropertyOrdersQuery.data?.data, [getPropertyOrdersQuery.data])

  return (
    <Stack paddingTop="3.2rem">
      <Grid container spacing={2.5} alignItems="start" direction={{ xs: 'column', sm: 'row' }}>

        {/* NO ORDERS */}
        {propertyOrdersData?.length === 0 ?
          <ClientPropertyEmptyContent
            title={t('no_property_order')}
            buttonText={t('no_property_order_action')}
            onButtonClick={() => {
              handleClickOnEmptyAction(AnalyticsEvent.PROPERTY_ORDER_VISUALS_CLICKED)
              navigate({ pathname: Path.PURCHASE_FLOW, search: `?realtyId=${propertyId}` })
            }}
            icon={<ShoppingCartOutlined fontSize='large' sx={{ color: GRAY_900 }} />}
          />
          :
          <>
            {/* ORDERS SUMMARY CARD & DETAILS */}
            <Grid item xs={12} md={4} width="100%">
              <ClientPropertyPriceSummaryCard />
            </Grid>

            <Grid item xs={12} md={8} width="100%">
              {propertyOrdersData && propertyOrdersData.map((order) => (

                <GalleryAssignmentContextProvider assignmentId={order.missions[0].id}>
                  <GalleryDealContextProvider assignmentId={order.missions[0].id} keepPreviousData={true}>

                    <Stack key={order.id} gap={2}>
                      <ClientGalleryOrderInformation context={OrderInformationContext.PROPERTY} />
                    </Stack>

                  </GalleryDealContextProvider>
                </GalleryAssignmentContextProvider>

              ))}
            </Grid>
          </>
        }
      </Grid>
    </Stack>
  )
}
